// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-permission-button {
  position: relative;
}
.dl-permission-button__content-container {
  display: flex;
  gap: var(--g-spacing-3);
  padding: var(--g-spacing-4);
  border-radius: var(--g-border-radius-l);
}
.dl-permission-button__content-container_disabled {
  color: var(--g-color-text-secondary);
  background-color: var(--g-color-base-generic);
}
.dl-permission-button__content {
  display: flex;
  flex-direction: column;
  gap: var(--g-spacing-1);
}
.dl-permission-button__status-icon-container {
  display: flex;
  gap: var(--g-spacing-1);
  position: absolute;
  top: 6px;
  right: 6px;
}
.dl-permission-button__check-icon {
  color: var(--g-color-base-brand);
}
.dl-permission-button__lock-icon {
  color: var(--g-color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogSharedEntryPermissions/components/PermissionButton/PermissionButton.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,uCAAA;AACR;AACQ;EACI,oCAAA;EACA,6CAAA;AACZ;AAGI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AADR;AAII;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAFR;AAKI;EACI,gCAAA;AAHR;AAMI;EACI,oCAAA;AAJR","sourcesContent":[".dl-permission-button {\n  position: relative;\n}\n.dl-permission-button__content-container {\n  display: flex;\n  gap: var(--g-spacing-3);\n  padding: var(--g-spacing-4);\n  border-radius: var(--g-border-radius-l);\n}\n.dl-permission-button__content-container_disabled {\n  color: var(--g-color-text-secondary);\n  background-color: var(--g-color-base-generic);\n}\n.dl-permission-button__content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--g-spacing-1);\n}\n.dl-permission-button__status-icon-container {\n  display: flex;\n  gap: var(--g-spacing-1);\n  position: absolute;\n  top: 6px;\n  right: 6px;\n}\n.dl-permission-button__check-icon {\n  color: var(--g-color-base-brand);\n}\n.dl-permission-button__lock-icon {\n  color: var(--g-color-text-secondary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
